import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import theme from 'theme/theme';
import normalisations from 'helpers/forms/normalisations';
import styled from 'styled-components';

const StyledContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    ${ (props) => {
        return props.style;
    } }
`;

const StyledUnitContainer = styled.div`
    margin: 0 0 10px 10px;
    color: ${ theme.palette.silver };

    ${ (props) => {
        return props.style;
    } }
`;

const PercentageInputField = (props) => {
    const {
        className,
        containerStyle,
        defaultValue,
        disabled,
        error,
        fullWidth,
        label,
        max,
        min,
        name,
        onBlur,
        onChange,
        onFocus,
        placeholder,
        style,
        touched,
        unitStyle,
        value,
    } = props;

    const handleChange = (e) => {
        let inputValue = e.target.value;

        if (inputValue) {
            inputValue = normalisations.inBetween(inputValue, min, max);
        }

        const event = new InputEvent('change');

        return onChange({
            ...event,
            target: {
                ...event.target,
                name,
                value: inputValue,
            },
        });
    };

    return (
        <StyledContainer style={ containerStyle }>
            <TextField
                className={ className }
                defaultValue={ defaultValue }
                disabled={ disabled }
                errorText={ touched && error }
                floatingLabelText={ label }
                fullWidth={ fullWidth }
                hintText={ placeholder }
                id={ name }
                max={ max }
                min={ min }
                onBlur={ onBlur }
                onChange={ handleChange }
                onFocus={ onFocus }
                style={ Object.assign({}, { flex: 1 }, style) }
                type='number'
                value={ value }
            />

            <StyledUnitContainer style={ unitStyle }>%</StyledUnitContainer>
        </StyledContainer>
    );
};

PercentageInputField.defaultProps = {
    containerStyle: {},
    fullWidth: false,
    max: '100',
    min: '0',
    type: 'text',
};

PercentageInputField.propTypes = {
    className: PropTypes.string,
    containerStyle: PropTypes.object,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.string,
    ]),
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    max: PropTypes.string,
    min: PropTypes.string,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    touched: PropTypes.bool,
    unitStyle: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

export default PercentageInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/PercentageInputField.js